export default __webpack_public_path__ + "static/media/scroll-down-arrow.b013ca45.svg";